import React, { useContext, useState, useEffect } from "react";
import { globalContext } from "../components/Layout/Layout";
import {
  Container,
  Row,
  Modal,
  ModalBody,
  ModalHeader,
  Input,
  Form,
  FormGroup,
  Label,
} from "reactstrap";
import "../styles/contact.css";
import "../index.css";
import "../styles/header.css";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { toggleLogin, toggleRegister } from "../Features/authSlice";
import { useDispatch, useSelector } from "react-redux";
import { loginFailure, loginStart, loginSuccess } from "../Features/userSlice";
import axios from "axios";
import { constants } from "../Utils/constants";

function Login() {
  const [Cred, setCred] = useState({ email: "", password: "" });

  // const { toggleLogin, loginModal, toggleRegister, signUpModal } =
  //   useContext(globalContext);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const loginModal = useSelector((state) => state.auth.loginModal);
  const signUpModal = useSelector((state) => state.auth.signUpModal);

  const onTextChange = (e) => {
    setCred({ ...Cred, [e.target.name]: e.target.value });
  };

  const navigateToCar = () => {
    dispatch(toggleLogin());
    navigate("/home");
    toast.success("Logged In Successfully !!!");
  };

  const handleSubmit = async (e) => {
    if (Cred.email.trim() === "") {
      toast.error("Email Field Cannot Be Empty !!!", { theme: "colored" });
    } else if (
      !/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(Cred.email)
    ) {
      toast.error("Email Address is Not Valid !!!", { theme: "colored" });
    } else if (Cred.password.trim() === "") {
      toast.error("Paasword Field Cannot Be Empty !!!", { theme: "colored" });
    }
    // !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/.test(
    //   Cred.password
    // )
    else {
      e.preventDefault();
      dispatch(loginStart());
      try {
        // axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
        const resp = await axios.post(constants.serverUrl+"/user/signIn", { ...Cred });
        if (resp.data?.status == false) {
          toast.error(resp.data?.message, {
            theme: "colored",
          });
          dispatch(loginFailure());
        } else {
          sessionStorage.setItem("token", resp.data.token);
          dispatch(loginSuccess(resp.data));
          navigateToCar();
        }
      } catch (err) {
        dispatch(loginFailure());
      }

      // sessionStorage.setItem("isValid", true);
      // sessionStorage.setItem("email", Cred.email);
      // sessionStorage.setItem("password", Cred.password);
    }
  };

  // useEffect(() => {
  //   setTimeout(() => {
  //     setCred({ email: "", password: "" });
  //   }, 10000);
  // }, [Cred]);

  useEffect(() => {
    // sessionStorage.setItem("isValid", "");
    //console.log(loginModal + " " + signUpModal);
  }, []);

  return (
    <Container className="">
      <Modal isOpen={loginModal} backdrop="static">
        <ModalHeader
          className="border-0 d-flex justify-content-center"
          toggle={() => dispatch(toggleLogin())}
        >
          <h3>
            <strong>Log in</strong>
          </h3>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Form method="post">
              <FormGroup floating>
                <Input
                  id="exampleEmail"
                  name="email"
                  placeholder="Enter Email Address"
                  type="email"
                  bsSize="sm"
                  onChange={onTextChange}
                  required
                />
                <Label for="exampleEmail">Email</Label>
              </FormGroup>{" "}
              <FormGroup floating>
                <Input
                  id="examplePassword"
                  name="password"
                  placeholder="Enter Password"
                  type="password"
                  bsSize="sm"
                  onChange={onTextChange}
                  required
                />
                <Label for="examplePassword">Password</Label>
                <div className="mb-4 mt-2">
                  {/* <Checkbox name='flexCheck' value='' id='flexCheckDefault' label='Remember me' /> */}
                  <a href="#">Forgot password?</a>
                </div>

                <div className="text-center d-flex justify-content-center flex-column text-md-start mt-4 pt-2">
                  {/* <Button
                    className="contact__btn"
                    size="lg"
                    onClick={toggleLogin}
                  >
                    Login
                  </Button> */}
                  <button
                    className=" contact__btn"
                    type="button"
                    onClick={handleSubmit}
                  >
                    Log in
                  </button>
                  <p className="small fw-bold mt-2 pt-1 mb-2">
                    Don't have an account?{" "}
                    <a
                      href="#"
                      className="credentialsGuards"
                      onClick={() => {
                        dispatch(toggleLogin());
                        if (!signUpModal) dispatch(toggleRegister());
                        document.body.style.overflow = "visible";
                      }}
                    >
                      Register
                    </a>
                  </p>
                </div>
              </FormGroup>
            </Form>
          </Row>
        </ModalBody>
      </Modal>
    </Container>
  );
}

export default Login;
